<template>
  <g
     :transform="(flip === true ? `translate(${x} ${y - 38}) rotate(90)`: `translate(${x} ${y + 38}) rotate(-90)`)"
     data-name="Ebene 2"
     id="Ebene_2">
    <g
       id="FSMA">
      <rect
         style="fill:#c7c7c7;stroke:#ffffff;stroke-linejoin:round"
         id="rect840"
         height="3"
         width="16"
         y="60.5"
         x="30.618999"
         class="cls-3" />
      <rect
         style="fill:#c7c7c7;stroke:#ffffff;stroke-linejoin:round"
         id="rect842"
         height="4"
         width="26"
         y="56.5"
         x="25.618999"
         class="cls-3" />
      <rect
         style="fill:#c7c7c7;stroke:#ffffff;stroke-linejoin:round"
         id="rect844"
         height="8"
         width="26"
         y="28.5"
         x="25.618999"
         class="cls-3" />
      <polygon
         style="fill:#c7c7c7;stroke:#ffffff;stroke-linejoin:round"
         id="polygon846"
         points="41.619,0.5 35.619,0.5 33.619,3.5 33.619,28.5 43.619,28.5 43.619,3.5 "
         class="cls-3" />
      <rect
         ry="2"
         style="fill:#c7c7c7"
         id="rect848"
         rx="2"
         height="20"
         width="34"
         y="36.5"
         x="21.618999"
         class="cls-4" />
      <rect
         ry="2"
         style="fill:none;stroke:#ffffff;stroke-linejoin:round"
         id="rect850"
         rx="2"
         height="20"
         width="34"
         y="36.5"
         x="21.618999"
         class="cls-5" />
      <g
         id="g876"
         clip-path="inset(25% 28% 28% 29%)"
         class="cls-6">
        <line
           style="fill:url(#linearGradient886);stroke:#ffffff;stroke-linejoin:round"
           id="line852"
           y2="68.255898"
           x2="63.415401"
           y1="25.3976"
           x1="20.5571"
           class="cls-7" />
        <line
           style="fill:url(#Unbenannter_Verlauf-2);stroke:#ffffff;stroke-linejoin:round"
           id="line854"
           y2="68.255898"
           x2="70.150002"
           y1="25.3976"
           x1="27.2917"
           class="cls-8" />
        <line
           style="fill:url(#Unbenannter_Verlauf-3);stroke:#ffffff;stroke-linejoin:round"
           id="line856"
           y2="68.255898"
           x2="76.884499"
           y1="25.3976"
           x1="34.026199"
           class="cls-9" />
        <line
           style="fill:url(#Unbenannter_Verlauf-4);stroke:#ffffff;stroke-linejoin:round"
           id="line858"
           y2="68.255898"
           x2="56.680901"
           y1="25.3976"
           x1="13.8226"
           class="cls-10" />
        <line
           style="fill:url(#Unbenannter_Verlauf-5);stroke:#ffffff;stroke-linejoin:round"
           id="line860"
           y2="68.255898"
           x2="49.9464"
           y1="25.3976"
           x1="7.0881"
           class="cls-11" />
        <line
           style="fill:url(#Unbenannter_Verlauf-6);stroke:#ffffff;stroke-linejoin:round"
           id="line862"
           y2="68.255898"
           x2="43.2118"
           y1="25.3976"
           x1="0.3536"
           class="cls-12" />
        <line
           style="fill:url(#Unbenannter_Verlauf-7);stroke:#ffffff;stroke-linejoin:round"
           id="line864"
           y2="68.255898"
           x2="13.8226"
           y1="25.3976"
           x1="56.680901"
           class="cls-13" />
        <line
           style="fill:url(#Unbenannter_Verlauf-8);stroke:#ffffff;stroke-linejoin:round"
           id="line866"
           y2="68.255898"
           x2="7.0881"
           y1="25.3976"
           x1="49.9464"
           class="cls-14" />
        <line
           style="fill:url(#Unbenannter_Verlauf-9);stroke:#ffffff;stroke-linejoin:round"
           id="line868"
           y2="68.255898"
           x2="0.3536"
           y1="25.3976"
           x1="43.2118"
           class="cls-15" />
        <line
           style="fill:url(#Unbenannter_Verlauf-10);stroke:#ffffff;stroke-linejoin:round"
           id="line870"
           y2="68.255898"
           x2="20.5571"
           y1="25.3976"
           x1="63.415401"
           class="cls-16" />
        <line
           style="fill:url(#Unbenannter_Verlauf-11);stroke:#ffffff;stroke-linejoin:round"
           id="line872"
           y2="68.255898"
           x2="27.2917"
           y1="25.3976"
           x1="70.150002"
           class="cls-17" />
        <line
           style="fill:url(#Unbenannter_Verlauf-12);stroke:#ffffff;stroke-linejoin:round"
           id="line874"
           y2="68.255898"
           x2="34.026199"
           y1="25.3976"
           x1="76.884499"
           class="cls-18" />
      </g>
    </g>
  </g>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    plugColor: String,
    x: Number,
    y: Number,
    flip: Boolean
  },
  data() {
    return {
      plugWidth: 88,
      plugHeight: 47
    };
  },
  computed: {
    ...mapGetters([
      'getCssColor'
    ]),
    color: function() {
      return this.getColor(this.plugColor);
    },
    yRecalculated: function() {
      return this.y - this.plugHeight / 2;
    }
  },
  methods: {
    getColor(colorName) {
      return this.getCssColor(colorName);
    },
    getNoseColor: colorName => {
      return this.getCssColor(colorName + "Nase");
    }
  }
};
</script>